import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const setupPlayerPlayerActionTypes = {
  SETUP: type('[Player] SETUP'),
  SETUP_SUCCESS: type('[Player] SETUP Success'),
  SETUP_FAIL: type('[Player] SETUP Fail'),
};

export class SetupPlayerAction implements Action {
  readonly type = setupPlayerPlayerActionTypes.SETUP;
  constructor(public payload?: string) {}
}

export class SetupPlayerSuccessAction implements Action {
  readonly type = setupPlayerPlayerActionTypes.SETUP_SUCCESS;
  constructor(public payload?: string) {}
}

export class SetupPlayerFailAction implements Action {
  readonly type = setupPlayerPlayerActionTypes.SETUP_FAIL;
  constructor(public payload?: string) {}
}
